import { TextField } from "@fluentui/react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UsePanelNuevoUbicacion } from "./UsePanelNuevoUbicacion";
import { useCallback } from "react";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";

export interface IPanelNuevoUbicacion extends IOpenPanel{
    nivel:number
}
export const PanelNuevoUbicacion=(props:IPanelNuevoUbicacion)=>{
    const {request,setRequest,postInsertarIncidente,loading,disableForm,reset,mensaje,status} = UsePanelNuevoUbicacion(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              disableButton={disableForm}
              onClick={postInsertarIncidente}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [disableForm,request]
      );
    return (
        <PanelDrawer isOpen={props.isOpen} textHeader={"Insertar Ubicación"} onDismiss={reset}
        status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
        <TextField 
         type="text"
         label="Nombre de ubicación"
         placeholder="Escribir aquí el nombre de ubicación"
         autoComplete="off"
         value={request.nombre}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,nombre:newValue})}
         }}
         />
        </PanelDrawer>
    )
}